var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 639,
    height: 639,
    viewBox: "0 0 639 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 79.875C53.25 65.1705 65.1705 53.25 79.875 53.25H559.125C573.83 53.25 585.75 65.1705 585.75 79.875V426C585.75 440.705 573.83 452.625 559.125 452.625H79.875C65.1705 452.625 53.25 440.705 53.25 426V79.875Z",
    fill: "#C4B6FF",
    stroke: "#B5CDFB",
    strokeWidth: 18,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.125 452.625H292.875V585.75H346.125V452.625Z",
    fill: "#7D55FF",
    stroke: "#B5CDFB",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.375 585.75H452.625",
    stroke: "#B5CDFB",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.375 239.625H239.625C232.273 239.625 226.312 245.585 226.312 252.938V359.438C226.312 366.789 232.273 372.75 239.625 372.75H399.375C406.726 372.75 412.688 366.789 412.688 359.438V252.938C412.688 245.585 406.726 239.625 399.375 239.625Z",
    fill: "#7D55FF",
    stroke: "#221B38",
    strokeWidth: 12,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M372.75 239.625V186.375C372.75 156.966 348.91 133.125 319.5 133.125C290.09 133.125 266.25 156.966 266.25 186.375V239.625H372.75Z",
    stroke: "#221B38",
    strokeWidth: 12,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.2173f45a6867a30812908ebe9367852b.svg";
export { ForwardRef as ReactComponent };